import Link from 'next/link';
import { IMenuItem } from '~/src/api/content/menu';
import * as ST from './styled';

interface IProps {
    item: IMenuItem;
}

const Promo = ({ item }: IProps): JSX.Element => {
    const { image, promo_title: title, promo_link: link, promo_description: desc } = item;

    return (
        <ST.PromoWrapper>
            <Link
                href={link ? link : '/'}
                prefetch={false}
            >
                <a>
                    {title &&
                        <ST.PromoTitle>
                            {title}
                        </ST.PromoTitle>
                    }
                    <ST.PromoImg image={image} />
                    {desc &&
                        <ST.PromoDesc>
                            {desc}
                        </ST.PromoDesc>
                    }
                </a>
            </Link>
        </ST.PromoWrapper>
    );
};

export default Promo;
